import React from 'react';
import classNames from 'classnames';

import InfoTable from '@buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import styles from './returnPerformanceStyles.scss';

const ReturnPerformanceLoading: React.FC = () => {
  return (
    <InfoTable title="Return Performance">
      {({ labelStyle, dataStyle }): React.ReactElement[] => {
        return [1, 2, 3, 4].map(
          (key): React.ReactElement => (
            <div key={key} className={styles.tableRow}>
              <div className={labelStyle}>
                <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
              </div>
              <div className={classNames(dataStyle)}>
                <Skeleton width={SKELETON_WIDTHS.MEDIUM} size={SKELETON_SIZES.SMALL} />
              </div>
            </div>
          )
        );
      }}
    </InfoTable>
  );
};

export default ReturnPerformanceLoading;
